'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _application = require('./application');

var _application2 = _interopRequireDefault(_application);

var _logger = require('../lib/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Provider = function () {
  function Provider() {
    (0, _classCallCheck3.default)(this, Provider);
  }

  (0, _createClass3.default)(Provider, [{
    key: 'init',
    value: function init(config) {
      var enforceSecurity = config.secret || config.acls.some(function (x) {
        return x !== '*';
      });

      // Set hidden attribute with script if not present and security is being enforced
      if (enforceSecurity && window.self !== window.top && !(document.documentElement.hasAttribute && document.documentElement.hasAttribute('hidden'))) {
        document.documentElement.setAttribute('hidden', null);

        // WARNING: Setting hidden attribute with script can be countered by
        // hackers using iframe sandbox attribute OR a frame busting technique.
        _logger2.default.warn('Security warning: Hidden attribute not detected on document and has been added.');
      }

      this.application = new _application2.default();
      this.application.init(config);
      this.application.launch();
    }
  }, {
    key: 'on',
    value: function on(eventName, listener) {
      this.application.on(eventName, listener);
    }
  }, {
    key: 'fullscreen',
    value: function fullscreen(source) {
      this.application.fullscreen(source);
    }
  }, {
    key: 'httpError',
    value: function httpError(error) {
      this.application.httpError(error);
    }
  }, {
    key: 'trigger',
    value: function trigger(event, detail) {
      this.application.trigger(event, detail);
    }
  }, {
    key: 'loadPage',
    value: function loadPage(url) {
      this.application.loadPage(url);
    }
  }]);
  return Provider;
}();

exports.default = Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/xfc/lib/provider/provider.js
// module id = 148
// module chunks = 0